import React, {useState, useEffect , useContext } from 'react';
import { Link } from 'react-router-dom';
import { Card, Row, Col, Space, Divider, Table, Statistic, Button } from 'antd';
import { SolutionOutlined, EyeOutlined, FacebookOutlined, CheckCircleTwoTone, CloseCircleTwoTone } from '@ant-design/icons';
import { dateFormat } from '../../utils';
import AddSeason from '../../components/AddSeason';
import * as Setting from '../../utils/AuthUtils';
import { MeContext } from '../../context/';
import { getPhoto } from '../../utils/ComponentUtils';
import UpdateLeague from '../../components/UpdateLeague';
import { motion } from 'motion/react';
import LocationMap from '../../components/LocationMap';
import AddLeagueLocation from '../../components/AddLeagueLocation';
import DeleteLeagueLocation from '../../components/DeleteLeagueLocation';

function League(props) {
  // console.warn('props di League: ',props);
  const me = useContext(MeContext);
  const [hasRights, setHasRights] = useState({isAdmin: false, isReferral: false});

  useEffect(() => {
    // console.warn('onEffect di League page!');
    const rights = {isAdmin: false, isReferral: false};
    rights.isAdmin = (me && me.payLoad ? me.payLoad.isAdmin : false)
    const lid = (me && me.payLoad ? me.payLoad.leaguesManaged : 0)
    // console.warn('valori di lid e props.id: ', lid, ' , ', props.id);
    rights.isReferral = (lid === parseInt(props.id) ? true : false)
    // console.warn('stato di hasRights: ', hasRights);
    setHasRights(rights)
  }, [me, props])


  const columnsSeasons = [
    {
        title: 'Season',
        dataIndex: 'name',
        key: 'name', 
    },
    {
        title: 'League',
        dataIndex: 'hostingLeague',
        key: 'hostingLeague',
        render: (state, record) => (<Space><Link to={'/leagues/'+record.hostingLeague.id+'/'}>{record.hostingLeague.leagueName}</Link></Space>)
    },
    {
        title: 'Start Date',
        dataIndex: 'startDate',
        render: (date) => dateFormat(date)
    },
    {
        title: 'End Date',
        dataIndex: 'endDate',
        render: (date) => dateFormat(date)
    },
    {
        title: 'Stages Played',
        dataIndex: 'stagesPlayed',
    },
    {
        title: 'Actions',
        dataIndex: 'id',
        render: (state, record) => (<Space><Link to={'/seasons/'+record.id+'/'}>
                    <EyeOutlined />
                </Link>
                </Space>),
    }
  ];

  const league = (props.league.data && props.league.data.payLoad !== null ? props.league.data.payLoad : {});
  const seasons = (props.seasons.data && props.seasons.data.payLoad !== null ? props.seasons.data.payLoad : []);
  const locations = (props.league.data && props.league.data.payLoad !== null && props.league.data.payLoad.locations ? props.league.data.payLoad.locations : []);

  function formatStatus(league) {
    if (league && league.status) {
      return "Active";
    }
    return "Inactive";
  }

  function formatPrefixStatus(league) {
    if (league && league.status) {
      return (<CheckCircleTwoTone twoToneColor="#52c41a" />)
    }
    return (<CloseCircleTwoTone twoToneColor="#eb2f96" />)
  }
  
  return (
    <motion.div initial={{opacity: 0}} animate={{opacity: 1}} exit={{opacity: 0}} style={{ padding: '0 50px' }}>
    <h1>
      {league.leagueName}
    </h1>
    <Card loading={props.league.pending && props.seasons.pending} >
      { league.imageUrl !== '' &&
        <Row gutter={16} justify="center">
          <Col span={6}>
            <img style={{ width: '100%'}} alt={league.leagueName} src={getPhoto(league.imageUrl)}></img>
          </Col>
        </Row>
      }
      <Row gutter={16}>
        <Col span={8}>
          <Statistic title="Status" value={formatStatus(league)} prefix={formatPrefixStatus(league)} />
        </Col>
        <Col span={8}>
            <Statistic title="Referral" value={league.referrerName} prefix={<SolutionOutlined />} />
        </Col>
        <Col span={8}>
            <Statistic title="Facebook" value={league.facebookUrl} prefix={<FacebookOutlined />} />
        </Col>
      </Row>
      { Setting.isLoggedIn() && (hasRights.isAdmin || hasRights.isReferral ) && 
            <Row justify="center">
              <Col span={6}><UpdateLeague league={league} rights={hasRights}/></Col>
            </Row>
      }
      <Divider>Locations</Divider>
      { locations && locations.length == 0 &&
          <p> There are no default locations for this league. </p>
      }
      { locations && locations.length > 0 &&
          <Row justify="center" gutter={[16, 24]}>
          {
            locations.map(location => (
              <Col span={12}>
                <Row justify="center" style={{ marginBottom: '10px' }}>
                  {location.name}<br/>{location.address}
                  <br/>
                  <LocationMap location={location} />
                </Row>
                { Setting.isLoggedIn() && (hasRights.isAdmin || hasRights.isReferral ) &&
                  <Row justify="center">
                    <DeleteLeagueLocation location={location} leagueId={league.id} />
                  </Row>
                }
              </Col>
            ))
          }
          </Row>
      }
      { Setting.isLoggedIn() && (hasRights.isAdmin || hasRights.isReferral ) &&
        <Row justify="center">
          <Col span={6}><AddLeagueLocation leagueId={league.id} rights={hasRights}/></Col>
        </Row>
      }
      <Divider>Seasons</Divider>
      <Row gutter={[16, 24]} style={{ marginBottom: '20px' }}>
        <Col className="gutter-row" xs={24} sm={24} md={24} lg={24} xl={24}>
          <div>
            <Card type="inner">
              <Table
                columns={columnsSeasons} 
                dataSource={seasons} 
                pagination={false} 
                loading={props.seasons.pending}
              />
              { (hasRights.isAdmin || hasRights.isReferral) &&
                <AddSeason />
              }
              
            </Card>
          </div>
        </Col>
      </Row>
    </Card>
    </motion.div>
  );
}

export default League;